import React from 'react';
import cls from 'classnames';
import makeIconName from '../../../../utils/makeIconName';
import { ICONS } from '../../../../constants/icons';
import styles from './index.module.scss';
const YearsPicker = ({ setYearsIndex, setMode, setYear, years, year }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.head },
            React.createElement("button", { type: 'button', "aria-label": 'Previous month', className: cls(makeIconName(ICONS.x24.arrow_left, 'x24'), styles.controls), onClick: () => setYearsIndex((prev) => prev - 1) }),
            React.createElement("button", { type: 'button', onClick: () => setMode('date') }, "Select year"),
            React.createElement("button", { type: 'button', "aria-label": 'Next month', className: cls(makeIconName(ICONS.x24.arrow_right, 'x24'), styles.controls), onClick: () => setYearsIndex((prev) => prev + 1) })),
        years.map((item) => (React.createElement("div", { key: item, className: cls(styles.item, {
                [styles.selected]: item === year
            }) },
            React.createElement("button", { type: 'button', onClick: () => {
                    setYear(item);
                    setMode('date');
                } }, item))))));
};
export default YearsPicker;
